import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

export interface CourseStarted {
  id: string
  type: string
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

const coursesStarted = ({ page = 1, perPage = 8, search = '' }) => {
  return api
    .get<{ data: CourseStarted[]; total: number }>('/courses/courses_started', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) => ({
      courses: data.data.map((premier) => premier.attributes),
      total: data.total,
    }))
}

export default coursesStarted
